// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"S2-z"};